import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ComingSoonTemplate = ({ featureName }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); 
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-4">
      <div className="max-w-3xl w-full bg-gray-800 rounded-lg p-8 text-center">
        <div className="flex items-center justify-start mb-6">
          <button 
            onClick={handleGoBack}
            className="p-2 rounded-full hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
        </div>
        
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-blue-400 mb-2">{featureName}</h1>
          <h1 className="text-3xl font-bold text-blue-400 mb-2">Coming Soon</h1>
          <p className="text-gray-300 text-lg">
            This feature is not yet implemented.
          </p>
          <p className="text-gray-400 mt-2">
            Our team is working on it to bring this functionality to you soon!
          </p>
        </div>
        
        <div className="animate-pulse">
          <div className="h-4 bg-gray-700 rounded-full w-3/4 mx-auto mb-2"></div>
          <div className="h-4 bg-gray-700 rounded-full w-1/2 mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export const ComingSoonAID = () => (
  <ComingSoonTemplate featureName="HW Change verification Assessment" />
);

export const ComingSoonLL = () => (
  <ComingSoonTemplate featureName="Audio Issue Visualization" />
);

export const ComingSoonMD = () => (
  <ComingSoonTemplate featureName="Mura Detection" />
);

// Alternatively, you could export all components as a single object
export default {
  ComingSoonAID,
  ComingSoonLL,
  ComingSoonMD
};